export default "__VITE_ASSET__DGlNJe4i__"